import Card from './Card'
import style from '../../styles/components/story-collection/story-collection'

const DesktopSection = ({ stories, layout, type }) => (
  <>
    <div className={`${layout} tablet-hide`}>
      {stories
        ?.filter((story) => story)
        ?.map((story) => (
          <div key={story.slug} className='card-container'>
            <Card cardType={type} story={story} />
          </div>
        ))}
    </div>
    <style jsx>{style}</style>
  </>
)

export default DesktopSection
